import { render } from "./productionProcess.vue?vue&type=template&id=4c486a98&ts=true"
import script from "./productionProcess.vue?vue&type=script&lang=ts"
export * from "./productionProcess.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__